import classNames from "classnames";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { Input } from "../../../components/input/input";

import styles from "./editMaterial.module.css";
import { UploadFiles } from "../../../components/uploadFiles/uplodeFiles";

import { Text } from "../../../components/text/text";

export const InputBlock = ({ type, title, value, setValue, className, min, max, error, editor, ...props }) => {
    return (
        <div className={classNames(styles.input_block, className)}>
            <Text as="div" variant="caption" className={styles.input_block_title} size={14}>
                {title}
            </Text>
            {type === "number" && <NumberInput error={error} val={value} setVal={setValue} min={min} max={max} {...props} />}
            {type === "textEditor" && editor}
            {type === "files" && <UploadFiles selectedFiles={value} setSelectedFiles={setValue} {...props} />}
            {type !== "number" && type !== "textEditor" && type !== "files" && <Input error={error} type={type} value={value} setValue={setValue} {...props} />}
        </div>
    )
}
